import { h, Component } from "preact";
import { Router } from "preact-router";
import AsyncRoute from "preact-async-route";
import { Provider } from "react-redux";
import queryString from "query-string";
import "./utils/PolyFill";
import create from "./state/store";
import config from "./config";
import Redirect from "./utils/Redirect";
import CountryDetect from "./components/CountryDetect";
import Loading from "./components/Loading";
import Share from "./components/navigation/Share";
import NotFoundPage from "./routes/404/404";
import HubspotInjector from "./components/HubspotInjector";

const env = config("ENV");

if (module.hot) {
  require("preact/debug");
}

export default class App extends Component {
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */
  routeChanged = false;
  handleRoute = e => {
    this.url = e.url;
    // hack to get zip money to init since they do not have a function we can call
    if (this.routeChanged && e.url === "/zipmoney") {
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    } else if (e.url !== "/zipmoney") {
      this.routeChanged = true;
    }
    try {
      if (typeof window !== "undefined") {
        window.scrollTo(0, 0);
      }
    } catch (e) {}
  };

  saveReferralCode = referralCode => {
    if (typeof window !== "undefined" && referralCode) {
      const date = new Date();
      const expires = new Date(date.getTime() + 30 * 60000);
      document.cookie = `referralcode=${referralCode}; expires=${expires.toUTCString()}; path=/;`;
    }
  };

  getReferralCode = () => {
    let referralCode;
    document.cookie.split(";").filter(item => {
      if (item.trim().indexOf("referralcode=") == 0) {
        referralCode = item.trim();
      }
    });
    return referralCode;
  };

  render({ url = "/", referralCode }) {
    let locale = "au";
    let detectedLocale = "au";
    let widget = url.indexOf("w=true") !== -1;
    if (typeof window !== "undefined") {
      url =
        window && window.location && window.location.pathname
          ? window.location.pathname
          : url;
      if (typeof window !== "undefined" && window.__PRELOADED_STATE__) {
        url = window.__PRELOADED_STATE__.url
          ? window.__PRELOADED_STATE__.url
          : url;
        locale = window.__PRELOADED_STATE__.locale
          ? window.__PRELOADED_STATE__.locale
          : locale;
        detectedLocale = window.__PRELOADED_STATE__.detectedLocale
          ? window.__PRELOADED_STATE__.detectedLocale
          : detectedLocale;
        referralCode = window.__PRELOADED_STATE__.referralCode
          ? window.__PRELOADED_STATE__.referralCode
          : referralCode;
        widget = window.__PRELOADED_STATE__.widget
          ? window.__PRELOADED_STATE__.widget
          : widget;
      }
      //yeet
      const search =
        typeof window !== "undefined" ? window.location.search : "";
      if (referralCode) {
        this.saveReferralCode(referralCode);
      } else {
        referralCode = this.getReferralCode();
      }
      //debugging for nz
      window.getLocale = () => {
        console.log(`locale: ${locale}, detectedtLocale: ${detectedLocale}`);
      };
    }
    const store = create({
      referralCode: referralCode,
      widget: widget
    });
    return (
      <Provider store={store}>
        <div id="app">
          <Share />
          <CountryDetect locale={locale} detectedLocale={detectedLocale} />
          <HubspotInjector />
          <Router onChange={this.handleRoute} url={url}>
            <NotFoundPage default />
            <AsyncRoute
              path="/:locale/"
              getComponent={() =>
                import("./routes/home").then(module => module.default)
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/about-us"
              getComponent={() =>
                import("./routes/aboutus/AboutUs").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/au/search"
              getComponent={() =>
                import("./routes/searchResults/SearchResultsPage").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/nz/search"
              getComponent={() =>
                import("./routes/searchResults/SearchResultsPage").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/find-events"
              getComponent={() =>
                import("./routes/findEvents/FindEventsPage").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/features-and-pricing"
              getComponent={() =>
                import("./routes/featuresAndPricing/FeaturesAndPricing").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/zipmoney"
              getComponent={() =>
                import("./routes/zipMoney/ZipMoney").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/our-story"
              getComponent={() =>
                import("./routes/ourStory/OurStory").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/contact-us/buyer-support/:enquiry?"
              getComponent={() =>
                import("./routes/contactUs/buyerSupport/BuyerSupport").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/contact-us/organiser-support"
              getComponent={() =>
                import(
                  "./routes/contactUs/organiserSupport/OrganiserSupport"
                ).then(module => module.default)
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/contact-us/general-support"
              getComponent={() =>
                import("./routes/contactUs/generalSupport/GeneralSupport").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/contact-us"
              getComponent={() =>
                import("./routes/contactUs/ContactUs").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/our-impact"
              getComponent={() =>
                import("./routes/ourImpact/OurImpact").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <Redirect path="/:locale/our-projects" to="/:locale/our-impact" />
            <AsyncRoute
              path="/:locale/events/online"
              getComponent={() =>
                import("./routes/seoSearchPage/SEOSearchPageOnline").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />

            <AsyncRoute
              path="/:locale/events/online/:time"
              getComponent={() =>
                import("./routes/seoSearchPage/SEOSearchPageOnline").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/events/:country/:location"
              getComponent={() =>
                import("./routes/seoSearchPage/SEOSearchPage").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/events/:country/:location/:time"
              getComponent={() =>
                import("./routes/seoSearchPage/SEOSearchPage").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/events/:time"
              getComponent={() =>
                import("./routes/seoSearchPage/SEOSearchPage").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/our-model"
              getComponent={() =>
                import("./routes/ourModel/OurModel").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/features"
              getComponent={() =>
                import("./routes/features/Features").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/our-impact/room-to-read"
              getComponent={() =>
                import("./routes/ourImpact/Projects/RoomToRead").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/au/our-impact/yalari"
              getComponent={() =>
                import("./routes/ourImpact/Projects/Yalari").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/nz/our-impact/kidscan"
              getComponent={() =>
                import("./routes/ourImpact/Projects/KidsCan").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/nz/our-impact/manaiakalani"
              getComponent={() =>
                import("./routes/ourImpact/Projects/Manaiakalani").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/us/our-impact/codeorg"
              getComponent={() =>
                import("./routes/ourImpact/Projects/CodeOrg").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/our-team"
              getComponent={() =>
                import("./routes/ourTeam/OurTeam").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/festivals"
              getComponent={() =>
                import("./routes/SeoLandingPages/Festivals").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/conferences"
              getComponent={() =>
                import("./routes/SeoLandingPages/Conferences").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/education"
              getComponent={() =>
                import("./routes/SeoLandingPages/Education").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            {/* <AsyncRoute
              path="/:locale/press"
              getComponent={() =>
                import("./routes/press/Press").then(module => module.default)
              }
              loading={() => <Loading />}
            /> */}
            <AsyncRoute
              path="/:locale/accessible-events"
              getComponent={() =>
                import("./routes/SeoLandingPages/AccessibleEvents").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/partners-and-supporters"
              getComponent={() =>
                import(
                  "./routes/partnersAndSupporters/PartnersAndSupporters"
                ).then(module => module.default)
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/charities"
              getComponent={() =>
                import("./routes/SeoLandingPages/Charity").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/government"
              getComponent={() =>
                import("./routes/SeoLandingPages/Government").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/live-shows"
              getComponent={() =>
                import("./routes/SeoLandingPages/LiveShows").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />
            <AsyncRoute
              path="/:locale/online"
              getComponent={() =>
                import("./routes/SeoLandingPages/Online").then(
                  module => module.default
                )
              }
              loading={() => <Loading />}
            />

            <Redirect path="/:locale/our-projects" to="/:locale/our-impact" />
            <Redirect path="/:locale/about-us" to="/:locale/our-story" />
            <Redirect
              path="/:locale/host-events"
              to="/:locale/features-and-pricing"
            />
          </Router>
        </div>
      </Provider>
    );
  }
}
